export const SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER';
export const RESET_VISIBILITY_FILTER = 'RESET_VISIBILITY_FILTER';

export const SET_SORT_KEY = 'SET_SORT_KEY';
export const RESET_SORT_KEY = 'RESET_SORT_KEY';

export const SET_DIFFICULTY_FILTER = 'SET_DIFFICULTY_FILTER';
export const RESET_DIFFICULTY_FILTER = 'RESET_DIFFICULTY_FILTER';

export const SET_TONALITY_FILTER = 'SET_TONALITY_FILTER';
export const RESET_TONALITY_FILTER = 'RESET_TONALITY_FILTER';

export const SET_STATUS_FILTER = 'SET_STATUS_FILTER';
export const RESET_STATUS_FILTER = 'RESET_STATUS_FILTER';

export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const RESET_TYPE_FILTER = 'RESET_TYPE_FILTER';

export const SET_AUTHOR_FILTER = 'SET_AUTHOR_FILTER';
export const RESET_AUTHOR_FILTER = 'RESET_AUTHOR_FILTER';
export const SET_AUTHOR_OPTIONS = 'SET_AUTHOR_OPTIONS';

export const SET_PERFORMER_FILTER = 'SET_PERFORMER_FILTER';
export const RESET_PERFORMER_FILTER = 'RESET_PERFORMER_FILTER';
export const SET_PERFORMER_OPTIONS = 'SET_PERFORMER_OPTIONS';
